module.exports = __webpack_public_path__ + "static/media/closeSquare.d66580a9.svg";